module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-settings-up@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/btn-settings-up@1x.png
// module id = 650
// module chunks = 0